/**
 * Phone Number Header - Server Component (Static)
 *
 * Renders immediately on server - no data fetching required.
 * This uses Next.js 16 PPR to show static content first, then stream dynamic data.
 */

import Link from 'next/link';
import { Phone, Plus } from 'lucide-react';

export function PhoneNumberHeader() {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-3">
        <div
          className="w-10 h-10 rounded-xl flex items-center justify-center"
          style={{ backgroundColor: 'var(--primary-color, #22577A)15' }}
        >
          <Phone size={20} style={{ color: 'var(--primary-color, #22577A)' }} />
        </div>
        <div>
          <h1 className="text-2xl font-semibold text-text-primary">Phone Number</h1>
          <p className="text-sm text-text-secondary">Manage your phone number, compliance, and consent settings</p>
        </div>
      </div>
      <Link
        href="/10dlc"
        className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-primary border border-primary/30 rounded-lg hover:bg-primary/5 transition-colors"
      >
        <Plus size={14} className="mr-1.5" />
        Register number
      </Link>
    </div>
  );
}
